export default {
  payWelfareText: 'مزايا الشحن',
  blackFridayDiscount: 'تخفيضات الجمعة البيضاء المحدودة',
  shareGift: 'شارك واربح',
  vipWeeklyWelfare: 'خصم أسبوعي للـVIP',
  exchangeCoupon: 'قسيمة',
  firstPayOff: 'خصم يصل إلى 15% عند الشراء الأول',
  blackFridayEvent: 'حدث الجمعة البيضاء',
  limitedTimeOff: 'خصم 10% لفترة محدودة',
  claimCoupon: 'استلام الآن',
  blackFridayTimedCoupon: 'قسيمة الجمعة البيضاء المحدودة',
  timeLeft: 'الوقت المتبقي:',
  claimTimeCoupon: 'احصل على قسيمة خصم 10% الآن!',
  points: 'النقاط: ${point}',
  costPointTip: 'استبدل النقاط بالقسائم',
  maxPointTip: 'كل حساب يمكنه استخدام ما يصل إلى 500 نقطة.',
  discountOff: 'خصم 10%',
  highestDiscount: '${discount} خصم يصل إلى ',
  needPoint: 'يتطلب ${point} نقطة ',
  changeCurrency: 'تغيير العملة',
  claim: 'استلام',
  claimSucc: 'تم الاستلام',
  claimFail: 'فشل',
  pointNotEnough: 'النقاط غير كافية',
  afterClaimPoint: 'النقاط المتبقية: ${point}',
  footTips1: 'يمكن استخدام قسيمة واحدة فقط لكل طلبية.',
  footTips2: 'لا يمكن استخدام القسيمة لشراء عملات/رموز اللعبة.',
  footTips3: 'نحن نحتفظ بالحق في التفسير النهائي لهذا الحدث.',
  ruleTitleText: 'قواعد الحدث',
  ruleTime: 'مدة الحدث: 00:00 24 نوفمبر 2023 إلى 23:59 26 نوفمبر 2023 (UTC)',
  bfRuleText1:
    '1. سيتم منح 400 نقطة إلى حسابك عند تسجيل الدخول إلى صفحة الشحن الرسمية لأول مرة أثناء الحدث. يمكنك استبدال ما يصل إلى 500 نقطة للحصول على قسائم.',
  bfRuleText2: '2. يمكنك استبدال نقاط الجمعة البيضاء بقسائم خلال الحدث.',
  bfRuleText3:
    '3. يمكنك استخدام قسيمة واحدة فقط لكل طلبية. لا يمكن استخدام القسائم لشراء عملات/رموز اللعبة.',
  bfRuleText4: '4. بالنسبة للمعاملات، نقبل فقط العملات التالية:',
  ableCoinsType:
    'الدولار الأمريكي، الين الياباني، الوون الكوري، الدولار التايواني، اليورو، دولار هونج كونج، الجنيه الاسترليني، الدولار الكندي، الدولار الاسترالي، الروبل الروسي، الرينغيت الماليزي، بات تايلاندي، الزلوتي البولندي، الروبية الإندونيسية.',
  bfRuleText5:
    '5. لا يجوز لك تغيير العملة بمجرد إجراء المعاملة، ولا يمكن استرداد النقاط المستبدلة.',
  bfRuleText6: '6. قسائم الجمعة البيضاء صالحة لمدة 7 أيام فقط.',
  bfRuleText7: '7. نحن نحتفظ بالحق في التفسير النهائي لهذا الحدث.',
  thanksTip:
    'نشكركم على مشاركتكم. يرجى الانضمام إلى مجتمع لاعبينا الرسمي لمزيد من المعلومات حول الحدث.',
  exchangePoints: 'مبادلة',
  exchangeCode: 'أدخل رمز المبادلة.',
  enterExchangeCode: 'الرجاء إدخال رمز المبادلة.',
  exchangeText: 'مبادلة',
  confirmGet: 'تأكيد',
  couponUsedWay:
    'لا يمكن استخدام القسيمة إلا بعملات محددة، يرجى تأكيد العملة الخاصة بك.',
  confirmText: 'تأكيد',
  exchangeSucc: 'تمت المبادلة',
  aboutCoins: 'حول عملات/رموز اللعبة',
  aboutCoinsText:
    'يمكنك استبدال العملات/الرموز داخل اللعبة بجميع الحزم والامتيازات باستثناء العملات/الرموز المميزة داخل اللعبة نفسها.',
  known: 'حسنًا',
  codeText: 'رمز المبادلة',
  codeInvalid: 'رمز المبادلة غير صالح!',
  hasExchanged: 'لا يجوز لك استلام المزيد من رموز المبادلة.',
  hideText: 'إخفاء',
  //黑五的报错码
  'bf-20001': 'لم يتم تسجيل الدخول',
  'bf-20002': 'خطأ في المُعامل، يرجى محاولة إعادة دخول الحدث',
  'bf-20003': 'النقاط غير كافية',
  'bf-20004': 'فشل الاستلام، يرجى المحاولة بعد قليل أو التواصل مع خدمة العملاء',
  'bf-20005': 'تم الاستلام',
  'bf-20015': 'الحدث لم يفتح بعد، يرجى تقرب فتحه',
  'bf-20016': 'انتهى الحدث',
  bfShareText: 'احصل على قسيمة خصم 10% الآن!',
  rightsCenterBtn: 'مركز العضوية المميزة',
  payBtn: 'الدفع',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorious Extraordinaire (Permanent)',
  '-': '-'
};
